import React from 'react'
import './book-with.css'

interface Props {
  templateName?: string
}

export const BackToTemplates = ({ templateName }: Props) => {
  const goBack = () => {
    const url = window.location.href.split('?')[0]
    window.location.href = `${url}/all`
  }

  return (
    <div className='fabe-navigate-back' onClick={goBack}>
      <div className='fabe-arrow-right' />
      <span className='fabe-template-name'>{templateName}</span>
    </div>
  )
}
